import {OAuth2AuthenticateOptions} from "@capacitor-community/generic-oauth2";
import {environment} from "../environments/environment";

export const cognitoOptions = {
  appId: environment.cognitoUserPoolClientId,                    // Cognito App client ID
  authorizationBaseUrl:
    `https://${environment.cognitoOAuthDomain}/oauth2/authorize/`,
  accessTokenEndpoint:
    `https://${environment.cognitoOAuthDomain}/oauth2/token/`,
  resourceUrl:
    `https://${environment.cognitoOAuthDomain}/oauth2/userInfo/`,
  scope: 'openid profile email',
  responseType: 'code',           // use “code” + PKCE
  pkceEnabled: true,
  logsEnabled: true,              // optional, but handy while wiring things up

  web: {
    redirectUrl: `${environment.baseUrl}/callback`,         // PWA / dev
    windowOptions: 'height=600,left=0,top=0',
    windowTarget: '_blank', // open in a new tab
  },
  android: {
    redirectUrl: 'io.myhomey.app://callback',                 // matches AndroidManifest
    responseType: 'code'
  },
  ios: {
    redirectUrl: 'io.myhomey.app://callback',                 // matches AndroidManifest
    responseType: 'code'
  }
} satisfies OAuth2AuthenticateOptions;
